// covered-by: frontends/carrie/src/routes/ask-puntt/__tests__/chats.test.tsx
import { useNavigate } from "@tanstack/react-router";

import { askPunttChatsRoute } from "./chatsRoute";
import { askPunttRoute } from "./route";
import { askPunttChatNavLink } from "./utils/chatNavigation";

import {
  AskPunttChatsView,
  chatMatchesLauncherQuery,
  formatChatDate,
  type ChatListItem,
} from "../../components/ask-puntt-list/AskPunttChatsView";

export { chatMatchesLauncherQuery, formatChatDate };

export default function AskPunttChats() {
  const navigate = useNavigate();

  return (
    <AskPunttChatsView
      listTo={askPunttChatsRoute.to}
      onOpenChat={(chat: ChatListItem) => {
        navigate(askPunttChatNavLink(chat));
      }}
      onNewChat={() => {
        navigate({ to: askPunttRoute.to });
      }}
    />
  );
}
